<template>
  <nav class="app-sidebar" :class="{ collapsed: isCollapsed, 'mobile-open': mobileOpen }" :style="!isMobile ? { width: isCollapsed ? '52px' : '200px' } : {}">
    <div class="s-logo">
      <span class="s-logo-text">GNM</span>
    </div>

    <ul class="s-nav">
      <!-- Dashboard (all roles) -->
      <li class="s-nav-item">
        <router-link to="/" exact-active-class="s-nav-active" class="s-nav-link" :title="isCollapsed ? 'Dashboard' : ''">
          <span class="s-icon" v-html="ICONS.grid"></span>
          <span class="s-label" v-if="!isCollapsed">Dashboard</span>
        </router-link>
      </li>

      <!-- ── MAIN ── -->
      <li class="s-section-header" v-if="!isCollapsed">MAIN</li>
      <li class="s-section-divider" v-else></li>

      <li class="s-nav-item" v-if="canSee('stats1')">
        <router-link to="/stats1" exact-active-class="s-nav-active" class="s-nav-link" :title="isCollapsed ? 'Statistics' : ''">
          <span class="s-icon" v-html="ICONS.chart"></span>
          <span class="s-label" v-if="!isCollapsed">Statistics</span>
        </router-link>
      </li>

      <li class="s-nav-item" v-if="canSee('clients1')">
        <router-link to="/clients1" exact-active-class="s-nav-active" class="s-nav-link" :title="isCollapsed ? 'Clients' : ''">
          <span class="s-icon" v-html="ICONS.users"></span>
          <span class="s-label" v-if="!isCollapsed">Clients</span>
        </router-link>
      </li>

      <li class="s-nav-item" v-if="canSee('tasks1')">
        <router-link to="/tasks1" exact-active-class="s-nav-active" class="s-nav-link" :title="isCollapsed ? 'Tasks' : ''">
          <span class="s-icon" v-html="ICONS.check"></span>
          <span class="s-label" v-if="!isCollapsed">Tasks</span>
        </router-link>
      </li>

      <li class="s-nav-item" v-if="canSee('shifts1')">
        <router-link to="/shifts1" exact-active-class="s-nav-active" class="s-nav-link" :title="isCollapsed ? 'Shifts' : ''">
          <span class="s-icon" v-html="ICONS.calendar"></span>
          <span class="s-label" v-if="!isCollapsed">Shifts</span>
        </router-link>
      </li>

      <li class="s-nav-item" v-if="canSee('users1')">
        <router-link to="/users1" exact-active-class="s-nav-active" class="s-nav-link" :title="isCollapsed ? 'Users' : ''">
          <span class="s-icon" v-html="ICONS.person"></span>
          <span class="s-label" v-if="!isCollapsed">Users</span>
        </router-link>
      </li>

      <!-- ── REVENUE ── -->
      <li class="s-section-header" v-if="!isCollapsed">REVENUE</li>
      <li class="s-section-divider" v-else></li>

      <li class="s-nav-item" v-if="canSee('finance1')">
        <router-link to="/finance1" exact-active-class="s-nav-active" class="s-nav-link" :title="isCollapsed ? 'Finance' : ''">
          <span class="s-icon" v-html="ICONS.card"></span>
          <span class="s-label" v-if="!isCollapsed">Finance</span>
        </router-link>
      </li>

      <li class="s-nav-item" v-if="canSee('brokers1')">
        <router-link to="/brokers1" exact-active-class="s-nav-active" class="s-nav-link" :title="isCollapsed ? 'Brokers' : ''">
          <span class="s-icon" v-html="ICONS.briefcase"></span>
          <span class="s-label" v-if="!isCollapsed">Brokers</span>
        </router-link>
      </li>

      <li class="s-nav-item" v-if="canSee('affiliation1')">
        <router-link to="/affiliation1" exact-active-class="s-nav-active" class="s-nav-link" :title="isCollapsed ? 'Affiliation' : ''">
          <span class="s-icon" v-html="ICONS.link"></span>
          <span class="s-label" v-if="!isCollapsed">Affiliation</span>
        </router-link>
      </li>

      <li class="s-nav-item" v-if="canSee('chat1')">
        <router-link to="/chat1" exact-active-class="s-nav-active" class="s-nav-link" :title="isCollapsed ? 'Chat' : ''">
          <span class="s-icon-wrap">
            <span class="s-icon" v-html="ICONS.chat"></span>
            <span v-if="chatUnread > 0" class="s-badge">{{ chatUnread > 99 ? '99+' : chatUnread }}</span>
          </span>
          <span class="s-label" v-if="!isCollapsed">Chat</span>
          <span v-if="!isCollapsed && chatUnread > 0" class="s-badge-label">{{ chatUnread > 99 ? '99+' : chatUnread }}</span>
        </router-link>
      </li>

      <li class="s-nav-item" v-if="canSee('communications1')">
        <router-link to="/communications1" exact-active-class="s-nav-active" class="s-nav-link" :title="isCollapsed ? 'Communications' : ''">
          <span class="s-icon" v-html="ICONS.mail"></span>
          <span class="s-label" v-if="!isCollapsed">Communications</span>
        </router-link>
      </li>

      <!-- ── TEAM ── -->
      <li class="s-section-header" v-if="!isCollapsed">TEAM</li>
      <li class="s-section-divider" v-else></li>

      <li class="s-nav-item" v-if="canSee('games1')">
        <router-link to="/games1" exact-active-class="s-nav-active" class="s-nav-link" :title="isCollapsed ? 'Games' : ''">
          <span class="s-icon" v-html="ICONS.game"></span>
          <span class="s-label" v-if="!isCollapsed">Games</span>
        </router-link>
      </li>

      <li class="s-nav-item" v-if="canSee('quiz1')">
        <router-link to="/quiz1" exact-active-class="s-nav-active" class="s-nav-link" :title="isCollapsed ? 'Quiz' : ''">
          <span class="s-icon" v-html="ICONS.question"></span>
          <span class="s-label" v-if="!isCollapsed">Quiz</span>
        </router-link>
      </li>

      <li class="s-nav-item" v-if="canSee('instruction1')">
        <router-link to="/instruction1" exact-active-class="s-nav-active" class="s-nav-link" :title="isCollapsed ? 'Instruction' : ''">
          <span class="s-icon" v-html="ICONS.book"></span>
          <span class="s-label" v-if="!isCollapsed">Instruction</span>
        </router-link>
      </li>

      <li class="s-nav-item" v-if="canSee('security1')">
        <router-link to="/security1" exact-active-class="s-nav-active" class="s-nav-link" :title="isCollapsed ? 'Security' : ''">
          <span class="s-icon" v-html="ICONS.shield"></span>
          <span class="s-label" v-if="!isCollapsed">Security</span>
        </router-link>
      </li>

      <li class="s-nav-item" v-if="canSee('settings1')">
        <router-link to="/settings1" exact-active-class="s-nav-active" class="s-nav-link" :title="isCollapsed ? 'Settings' : ''">
          <span class="s-icon" v-html="ICONS.cog"></span>
          <span class="s-label" v-if="!isCollapsed">Settings</span>
        </router-link>
      </li>

      <!-- ── OPERATIONS ── -->
      <li class="s-section-header" v-if="!isCollapsed">OPERATIONS</li>
      <li class="s-section-divider" v-else></li>

      <li class="s-nav-item" v-if="canSee('project')">
        <router-link to="/project" exact-active-class="s-nav-active" class="s-nav-link" :title="isCollapsed ? 'Projects' : ''">
          <span class="s-icon" v-html="ICONS.folder"></span>
          <span class="s-label" v-if="!isCollapsed">Projects</span>
        </router-link>
      </li>

      <li class="s-nav-item" v-if="canSee('contacts')">
        <router-link to="/contacts" exact-active-class="s-nav-active" class="s-nav-link" :title="isCollapsed ? 'Contacts' : ''">
          <span class="s-icon" v-html="ICONS.addressBook"></span>
          <span class="s-label" v-if="!isCollapsed">Contacts</span>
        </router-link>
      </li>

      <li class="s-nav-item" v-if="canSee('inventory')">
        <router-link to="/inventory" exact-active-class="s-nav-active" class="s-nav-link" :title="isCollapsed ? 'Inventory' : ''">
          <span class="s-icon" v-html="ICONS.box"></span>
          <span class="s-label" v-if="!isCollapsed">Inventory</span>
        </router-link>
      </li>

      <li class="s-nav-item" v-if="canSee('orders')">
        <router-link to="/orders" exact-active-class="s-nav-active" class="s-nav-link" :title="isCollapsed ? 'Orders' : ''">
          <span class="s-icon" v-html="ICONS.shoppingCart"></span>
          <span class="s-label" v-if="!isCollapsed">Orders</span>
        </router-link>
      </li>
    </ul>

    <button class="s-toggle" @click="toggle" :title="isCollapsed ? 'Expand' : 'Collapse'">
      <svg v-if="isCollapsed" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
      <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
    </button>
  </nav>
</template>

<script>
import { mapState, mapGetters } from "vuex";

const ICONS = {
  grid: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>`,
  users: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>`,
  check: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>`,
  calendar: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>`,
  chart: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>`,
  chat: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>`,
  person: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>`,
  briefcase: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>`,
  card: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>`,
  shield: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>`,
  mail: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>`,
  link: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>`,
  game: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="6" y1="12" x2="10" y2="12"/><line x1="8" y1="10" x2="8" y2="14"/><circle cx="16" cy="11" r="1" fill="currentColor"/><circle cx="18" cy="13" r="1" fill="currentColor"/><path d="M6 20h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2z"/></svg>`,
  question: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>`,
  cog: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>`,
  book: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>`,
  folder: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>`,
  addressBook: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 2h14a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z"/><path d="M16 2v20"/><path d="M8 10h4"/><path d="M8 14h4"/></svg>`,
  box: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>`,
  shoppingCart: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>`
};

// Role-based visibility map.
// Key = route name (without leading slash), value = array of allowed role numbers.
// Role 1 = Admin, 2 = VP Sales, 3 = Manager, 4 = Agent, 5 = Chat Agent
const ROLE_MAP = {
  stats1:          [1, 2, 3],
  clients1:        [1, 2, 3, 4, 5],
  tasks1:          [1, 2, 3, 4],
  shifts1:         [1, 2, 3],
  users1:          [1, 2, 3],
  finance1:        [1, 2],
  brokers1:        [1, 2],
  affiliation1:    [1],
  chat1:           [1, 2, 3, 4, 5],
  communications1: [1, 2, 3],
  games1:          [1, 2, 4],
  quiz1:           [1, 4],
  instruction1:    [1, 4],
  security1:       [1],
  settings1:       [1],
  project:         [1, 2, 3],
  contacts:        [1, 2, 3, 4],
  inventory:       [1, 2, 3],
  orders:          [1, 2, 3],
};

export default {
  name: "AppSidebar",
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("main", ["chatUnread"])
  },
  data() {
    const saved = localStorage.getItem("gnm_sidebar_collapsed");
    return {
      isCollapsed: saved !== null ? saved === "true" : true,
      isMobile: typeof window !== 'undefined' && window.innerWidth < 768,
      mobileOpen: false,
      ICONS
    };
  },
  mounted() {
    this.$emit("widthChange", this.isCollapsed ? 52 : 200);
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobile);
  },
  methods: {
    toggle() {
      if (this.isMobile) {
        this.mobileOpen = !this.mobileOpen;
        this.$emit("mobileToggle", this.mobileOpen);
      } else {
        this.isCollapsed = !this.isCollapsed;
        localStorage.setItem("gnm_sidebar_collapsed", String(this.isCollapsed));
        this.$emit("widthChange", this.isCollapsed ? 52 : 200);
      }
    },
    closeMobile() {
      this.mobileOpen = false;
      this.$emit("mobileToggle", false);
    },
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
      if (this.isMobile) {
        this.isCollapsed = true;
        this.$emit("widthChange", 0);
      } else {
        this.mobileOpen = false;
      }
    },
    canSee(routeKey) {
      const allowed = ROLE_MAP[routeKey];
      if (!allowed) return true;
      const role = this.auth && this.auth.user && this.auth.user.role;
      if (!role) return false;
      return allowed.includes(Number(role));
    }
  }
};
</script>

<style scoped>
.app-sidebar {
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  background: #fff;
  border-right: 1px solid #e8eaed;
  display: flex;
  flex-direction: column;
  z-index: 300;
  transition: width 0.2s ease;
  overflow: hidden;
}

.s-logo {
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #e8eaed;
  flex-shrink: 0;
}

.s-logo-text {
  color: #6366f1;
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 1px;
}

.s-nav {
  list-style: none;
  margin: 0;
  padding: 6px 0;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.s-nav::-webkit-scrollbar { width: 3px; }
.s-nav::-webkit-scrollbar-track { background: transparent; }
.s-nav::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 2px; }

.s-nav-item { margin: 0; }

.s-section-header {
  padding: 10px 17px 4px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: #94a3b8;
  text-transform: uppercase;
  user-select: none;
}

.s-section-divider {
  height: 1px;
  background: #e8eaed;
  margin: 6px 12px;
}

.s-nav-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 17px;
  color: #64748b;
  text-decoration: none;
  transition: background 0.15s, color 0.15s;
  white-space: nowrap;
  border-left: 3px solid transparent;
}

.s-nav-link:hover {
  background: #f1f5f9;
  color: #1e293b;
}

.s-nav-link.s-nav-active {
  border-left-color: #6366f1;
  background: #eef2ff;
  color: #4f46e5;
}

.s-icon {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.s-label {
  font-size: 13px;
  font-weight: 500;
}

.s-toggle {
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  border-top: 1px solid #e8eaed;
  color: #94a3b8;
  cursor: pointer;
  width: 100%;
  flex-shrink: 0;
  transition: color 0.15s;
}

.s-toggle:hover { color: #1e293b; }

.s-icon-wrap {
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.s-badge {
  position: absolute;
  top: -5px;
  right: -6px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background: #ef4444;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  box-sizing: border-box;
}

.s-badge-label {
  margin-left: auto;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: #ef4444;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  box-sizing: border-box;
}
</style>

<style>
@media (max-width: 767px) {
  /* Sidebar hidden by default on mobile — slides in as overlay when .mobile-open */
  .app-sidebar {
    transform: translateX(-100%);
    width: 220px !important;
    transition: transform 0.25s ease, box-shadow 0.25s ease;
    box-shadow: none;
    z-index: 1200;
  }
  .app-sidebar.mobile-open {
    transform: translateX(0);
    box-shadow: 4px 0 24px rgba(0,0,0,0.18);
  }
  /* Show labels even in "collapsed" state on mobile overlay */
  .app-sidebar.mobile-open .s-label { display: block !important; }
  .app-sidebar.mobile-open .s-section-header { display: block !important; }
  .app-sidebar.mobile-open .s-section-divider { display: none !important; }
  /* Overlay backdrop */
  .mob-nav-backdrop {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.35);
    z-index: 1199;
  }
}
@media (min-width: 768px) {
  .mob-nav-backdrop { display: none !important; }
  .mob-hamburger { display: none !important; }
}
</style>
